// Arbitrary upper bound on a deep-link-seeded message. Not enforced by the
// backend; chosen to keep seeded prompts short and the URL reasonable.
const SEEDED_MESSAGE_MAX_LENGTH = 300

// Shared by every seeded-message source (query param, hash param): trims,
// caps, and rejects anything that isn't a single string (e.g. a repeated
// param, which the router surfaces as an array).
export function sanitizeSeededMessage(value: unknown): string {
  if (typeof value !== 'string') {
    return ''
  }

  return value.trim().slice(0, SEEDED_MESSAGE_MAX_LENGTH)
}
